// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Baloo+2:wght@400..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
    display: flex;
    flex-direction: row; /* Organise les enfants horizontalement */
    height: 100vh; /* Utilise toute la hauteur de l'écran */
    background-color: #FDFCF4; /* Applique la couleur de fond à la zone spécifique */

  }
  
  .left-container,
  .right-container {
    flex: 1 1; /* Prend 50% de la largeur */
    padding: 20px;
    display: flex;
    flex-direction: column; /* Organise les éléments verticalement */
    justify-content: flex-start;
    }
    
  .home-image {
    width: 100%; /* L'image prend toute la largeur du conteneur */
    height: 100%; /* L'image prend toute la hauteur du conteneur */
    object-fit: cover; /* L'image s'adapte à la taille du conteneur sans distorsion */
  }


  .image-banner {
    width: 100%; /* L'image prend toute la largeur de la demi-page */
    height: 20%; /* La hauteur est de 50% de la hauteur totale de la demi-page */
    display: flex;
    flex-direction: column;
    align-items: center; /* Centre l'image verticalement */
    justify-content: flex-start;
    margin-bottom: 20px; /* Espacement entre l'image et le texte */
  }
  
  /* .banner-image : ajuster l'image à la taille du conteneur */
  .banner-image {
    width: 50%; /* L'image prend toute la largeur de son conteneur */
    height: 80%; /* L'image occupe toute la hauteur de son conteneur */
    object-fit: contain; /* L'image est redimensionnée sans déformation pour entrer dans le conteneur*/
  }

  .text-container {
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centre verticalement le texte et les boutons */
    text-align: center; /* Centre le texte si nécessaire */

  }
  
  .next-button1 {
    background-color: #1C7862; /* Couleur de fond */
    color: white; /* Couleur du texte */
    font-family: 'Baloo 2', sans-serif;
    font-weight: bold; /* Pour un effet gras */
    border: none; /* Supprime la bordure */
    padding: 10px 20px; /* Espacement intérieur */
    font-size: 16px; /* Taille de la police */
    cursor: pointer; /* Change le curseur au survol */
    border-radius: 5px; /* Arrondit les coins */
    margin-top: 20px; /* Espace au-dessus du bouton */
    width: 50%; /* Le bouton occupe un tiers de la largeur de son conteneur */
    max-width: 300px; /* Optionnel : définit une largeur maximale */
    min-width: 150px; /* Optionnel : définit une largeur minimale */
    margin: 0 auto; /* Cette règle centre le bouton horizontalement */

  }
  
  
  /* Optionnel : Modifier la couleur au survol */
  .next-button:hover {
    background-color: #00B685; /* Couleur de fond au survol */
  }

  h1 {
    font-family: 'Baloo 2', sans-serif;
    font-weight: bold; /* Pour un effet gras */
    font-size: 40px;
    color: #1C7862
  }
  
  h2 {
    font-family: 'Montserrat', sans-serif;
    font-weight: normal;
    font-size: medium;
    margin-left: 150px;
    margin-right: 150px;
  }
  

  h3 {
    font-family: 'Montserrat', sans-serif;
    font-weight: normal;
    font-size: medium;
    margin-left: 150px;
    margin-right: 150px;
  }
  `, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB,EAAE,yCAAyC;IAC9D,aAAa,EAAE,wCAAwC;IACvD,yBAAyB,EAAE,qDAAqD;;EAElF;;EAEA;;IAEE,SAAO,EAAE,4BAA4B;IACrC,aAAa;IACb,aAAa;IACb,sBAAsB,EAAE,wCAAwC;IAChE,2BAA2B;IAC3B;;EAEF;IACE,WAAW,EAAE,gDAAgD;IAC7D,YAAY,EAAE,gDAAgD;IAC9D,iBAAiB,EAAE,8DAA8D;EACnF;;;EAGA;IACE,WAAW,EAAE,mDAAmD;IAChE,WAAW,EAAE,+DAA+D;IAC5E,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,iCAAiC;IACtD,2BAA2B;IAC3B,mBAAmB,EAAE,yCAAyC;EAChE;;EAEA,6DAA6D;EAC7D;IACE,UAAU,EAAE,oDAAoD;IAChE,WAAW,EAAE,qDAAqD;IAClE,mBAAmB,EAAE,6EAA6E;EACpG;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,iDAAiD;IAC1E,kBAAkB,EAAE,kCAAkC;;EAExD;;EAEA;IACE,yBAAyB,EAAE,oBAAoB;IAC/C,YAAY,EAAE,qBAAqB;IACnC,kCAAkC;IAClC,iBAAiB,EAAE,uBAAuB;IAC1C,YAAY,EAAE,wBAAwB;IACtC,kBAAkB,EAAE,yBAAyB;IAC7C,eAAe,EAAE,wBAAwB;IACzC,eAAe,EAAE,gCAAgC;IACjD,kBAAkB,EAAE,uBAAuB;IAC3C,gBAAgB,EAAE,+BAA+B;IACjD,UAAU,EAAE,6DAA6D;IACzE,gBAAgB,EAAE,6CAA6C;IAC/D,gBAAgB,EAAE,6CAA6C;IAC/D,cAAc,EAAE,iDAAiD;;EAEnE;;;EAGA,8CAA8C;EAC9C;IACE,yBAAyB,EAAE,8BAA8B;EAC3D;;EAKA;IACE,kCAAkC;IAClC,iBAAiB,EAAE,uBAAuB;IAC1C,eAAe;IACf;EACF;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;;EAGA;IACE,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB","sourcesContent":[".home-container {\r\n    display: flex;\r\n    flex-direction: row; /* Organise les enfants horizontalement */\r\n    height: 100vh; /* Utilise toute la hauteur de l'écran */\r\n    background-color: #FDFCF4; /* Applique la couleur de fond à la zone spécifique */\r\n\r\n  }\r\n  \r\n  .left-container,\r\n  .right-container {\r\n    flex: 1; /* Prend 50% de la largeur */\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column; /* Organise les éléments verticalement */\r\n    justify-content: flex-start;\r\n    }\r\n    \r\n  .home-image {\r\n    width: 100%; /* L'image prend toute la largeur du conteneur */\r\n    height: 100%; /* L'image prend toute la hauteur du conteneur */\r\n    object-fit: cover; /* L'image s'adapte à la taille du conteneur sans distorsion */\r\n  }\r\n\r\n\r\n  .image-banner {\r\n    width: 100%; /* L'image prend toute la largeur de la demi-page */\r\n    height: 20%; /* La hauteur est de 50% de la hauteur totale de la demi-page */\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; /* Centre l'image verticalement */\r\n    justify-content: flex-start;\r\n    margin-bottom: 20px; /* Espacement entre l'image et le texte */\r\n  }\r\n  \r\n  /* .banner-image : ajuster l'image à la taille du conteneur */\r\n  .banner-image {\r\n    width: 50%; /* L'image prend toute la largeur de son conteneur */\r\n    height: 80%; /* L'image occupe toute la hauteur de son conteneur */\r\n    object-fit: contain; /* L'image est redimensionnée sans déformation pour entrer dans le conteneur*/\r\n  }\r\n\r\n  .text-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Centre verticalement le texte et les boutons */\r\n    text-align: center; /* Centre le texte si nécessaire */\r\n\r\n  }\r\n  \r\n  .next-button1 {\r\n    background-color: #1C7862; /* Couleur de fond */\r\n    color: white; /* Couleur du texte */\r\n    font-family: 'Baloo 2', sans-serif;\r\n    font-weight: bold; /* Pour un effet gras */\r\n    border: none; /* Supprime la bordure */\r\n    padding: 10px 20px; /* Espacement intérieur */\r\n    font-size: 16px; /* Taille de la police */\r\n    cursor: pointer; /* Change le curseur au survol */\r\n    border-radius: 5px; /* Arrondit les coins */\r\n    margin-top: 20px; /* Espace au-dessus du bouton */\r\n    width: 50%; /* Le bouton occupe un tiers de la largeur de son conteneur */\r\n    max-width: 300px; /* Optionnel : définit une largeur maximale */\r\n    min-width: 150px; /* Optionnel : définit une largeur minimale */\r\n    margin: 0 auto; /* Cette règle centre le bouton horizontalement */\r\n\r\n  }\r\n  \r\n  \r\n  /* Optionnel : Modifier la couleur au survol */\r\n  .next-button:hover {\r\n    background-color: #00B685; /* Couleur de fond au survol */\r\n  }\r\n\r\n\r\n  @import url('https://fonts.googleapis.com/css2?family=Baloo+2:wght@400..800&display=swap');\r\n\r\n  h1 {\r\n    font-family: 'Baloo 2', sans-serif;\r\n    font-weight: bold; /* Pour un effet gras */\r\n    font-size: 40px;\r\n    color: #1C7862\r\n  }\r\n  \r\n  h2 {\r\n    font-family: 'Montserrat', sans-serif;\r\n    font-weight: normal;\r\n    font-size: medium;\r\n    margin-left: 150px;\r\n    margin-right: 150px;\r\n  }\r\n  \r\n\r\n  h3 {\r\n    font-family: 'Montserrat', sans-serif;\r\n    font-weight: normal;\r\n    font-size: medium;\r\n    margin-left: 150px;\r\n    margin-right: 150px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
